type NetInfoState = {
  isConnected: boolean
  isInternetReachable: boolean
  type: string
}

type Listener = (state: NetInfoState) => void

const listeners = new Set<Listener>()

function currentState(): NetInfoState {
  const online = typeof navigator !== "undefined" ? navigator.onLine : true
  return {
    isConnected: online,
    isInternetReachable: online,
    type: online ? "wifi" : "none",
  }
}

if (typeof window !== "undefined") {
  window.addEventListener("online", () => listeners.forEach((fn) => fn(currentState())))
  window.addEventListener("offline", () => listeners.forEach((fn) => fn(currentState())))
}

export default {
  fetch: async () => currentState(),
  addEventListener: (_type: string, listener: Listener) => {
    listeners.add(listener)
    return () => listeners.delete(listener)
  },
}

export async function fetch() {
  return currentState()
}

export function addEventListener(_type: string, listener: Listener) {
  listeners.add(listener)
  return () => listeners.delete(listener)
}
